if (!customElements.get("success-popup")) {
  customElements.define(
    "success-popup",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initForm();
      }

      initForm() {
        const button = this.querySelector("button");
        const emailInput = this.querySelector('input[type="email"]');
        const passwordInput = this.querySelector('input[type="password"]');
        const emailError = this.querySelector("#RegisterForm-email-error");
        const passwordError = this.querySelector(
          "#RegisterForm-password-error"
        );

        if (button) {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            const emailVal = emailInput.value;
            const passwordVal = passwordInput.value;

            if (emailVal === "") {
              emailError.classList.remove("hidden");
            } else {
              emailError.classList.add("hidden");
            }

            if (passwordVal === "") {
              passwordError.classList.remove("hidden");
            } else {
              passwordError.classList.add("hidden");
            }

            if (emailVal && passwordVal) {
              localStorage.setItem("register_success", "true");
              this.closest("form").submit();
            }
          });
        }
      }
    }
  );
}
